<template>
  <div id="app">
    <Tabbar v-if="!$route.meta.showNav"></Tabbar>
    <router-view></router-view>
  </div>
</template>

<script>
import { getUserInfo } from "./api/api";
import Tabbar from "./components/Tabbar.vue";
// import Vconsole from "vconsole";
export default {
  name: "App",
  components: {
    Tabbar,
  },
  data() {
    return {};
  },
  created() {
    this.$watch(() => {
      if (
        this.$route.name != null && this.$route.name != 'login' && this.$route.name != 'register'
      ) {
        this.getUserInfo();
      }
    });
  },
  computed: {},
  mounted() {
    // new Vconsole();
  },
  methods: {
    getUserInfo() {
      getUserInfo({ openid: this.$store.state.OPENID }).then((res) => {
        if (Object.keys(res).length > 0) {
          // this.$store.commit("updateUserInfo", res);
          this.$store.dispatch("updateUserInfo", res);
        } else {
          this.$store.commit("updateOpenid", '');
          // this.$store.commit("updateUserInfo", '');
          this.$store.dispatch("updateUserInfo", '');
          this.$store.commit("changeLogin", '');
        }
      });
    },
  },
};
</script>

